import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import AirportSummary from '../../../../elements/summary/shared/AirportSummary'
import DaysSummary from '../../../../elements/summary/shared/DaysSummary'
import DepartureDate from '../../../../elements/summary/shared/DepartureDate'
import NoteSummary from '../../../../elements/summary/shared/NoteSummary'
import NrPeopleSummary from '../../../../elements/summary/shared/NrPeopleSummary'

import { FunnelOrder } from '../../../../data/models/funnelOrder'
import { getRoomType } from '../../../../data/models/funnelOrder/roomType'
import { getDestination } from '../../../../data/models/funnelOrder/summary'
import { SiteLanguage } from '../../../../data/models/locale'
import { AppState } from '../../../../data/state'

interface TotmSummaryProps {
  funnelOrder: FunnelOrder
  language: SiteLanguage
  loading: boolean
  final?: boolean
}

const TotmSummary: React.FC<TotmSummaryProps> = ({
  funnelOrder,
  language,
  loading,
}) => {
  const loadingClass = loading ? 'is-loading' : ''

  return (
    <>
      <NrPeopleSummary />
      <DepartureDate />
      <DaysSummary
        contentKey="surfNBeach-days"
        getDestination={getDestination}
        destination={funnelOrder.destination}
      />
      <AirportSummary />
      <ListItem>
        <span className={loadingClass}>
          {getRoomType(funnelOrder.roomType)}
          {` `}
          <DisplayContent contentKey="accomodation-summary">
            accomodation
          </DisplayContent>
        </span>
      </ListItem>
      <NoteSummary />
    </>
  )
}

export default connect((state: AppState) => ({
  funnelOrder: state.funnelOrder,
  language: state.locale.language,
  loading: state.contentEngine.loading,
}))(TotmSummary)
